/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const BrushLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m15.46 9.68-.15-.15a5.5 5.5 0 0 0-2.39-1.35 5.2 5.2 0 0 0-6.6 4.63 7.5 7.5 0 0 1-1.8 4.67A21 21 0 0 0 11.5 19a5.5 5.5 0 0 0 3.96-9.32M13.29 6.2l4.94-3.84a1 1 0 0 1 1.32.08l3 3a1 1 0 0 1 .08 1.32l-3.85 4.94A7.5 7.5 0 0 1 11.5 21c-3.5-.01-8-1.51-10.5-3.01 3.98-3 3.05-4.81 3.5-6.5a7.2 7.2 0 0 1 8.79-5.29m3.41 1.9.2.2 1.13 1.13 2.47-3.18-1.74-1.75-3.18 2.48z" />
  </Icon>
);
